/**
 * The version of `tough-cookie`
 * @public
 */
export const version = '6.0.1'
